import { Tool, ToolSupportLevel } from '__generated__/api-types-and-hooks'
import Button, { ButtonVariantType } from 'components/Common/Button'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getCurrentRoute, onLaunchTool } from 'utils/helper'
import ToolFlyoutPopup from 'components/Owner/Tools/ToolFlyout/ToolFlyoutPopup'
import history from 'utils/history'
import { ExtendedTools } from 'types'
import { useFeatureFlag } from 'hooks/userFeatureFlag'
import { useSelector } from 'react-redux'
import { RootState } from 'App'
import { IGetOAuthUrlAction } from 'types'

interface IToolsButtonProps {
  isConnected: boolean
  ExternalLinkLaunch: string
  tool: ExtendedTools
  setActiveConnectingTool?: (param: Tool) => void
  getOAuthUrlAction: (payload: IGetOAuthUrlAction) => void
  buttonType?: ButtonVariantType
  isNewTools?: boolean
}

const ToolsButton: FC<IToolsButtonProps> = ({
  isConnected,
  ExternalLinkLaunch,
  tool,
  setActiveConnectingTool,
  getOAuthUrlAction,
  buttonType = 'secondary',
  isNewTools = false,
}) => {
  const [isOpen, setOpen] = useState(false)
  const { t } = useTranslation()

  const userId = useSelector((state: RootState) => state.user.user?.id)

  const isToolConnectable = tool.supportLevel && tool.supportLevel !== ToolSupportLevel.Open
  const connectTools = () => {
    if (!tool.options?.connectionForm) {
      getOAuthUrlAction({
        calendar: tool.toolName ?? '',
        targetOrigin: window.location.href,
        connectorName: tool.toolName ?? '',
        authType: tool.authType,
      })
    }
    setActiveConnectingTool && setActiveConnectingTool(tool)
  }
  const path = getCurrentRoute()

  const handleClick = (tabName) => {
    history.push(`${path}/${tabName}?toolId=${tool.id}`)
  }
  const isReleaseToolEnabled = useFeatureFlag(userId, 'release-tool-flyout-menu')
  return (
    <>
      <div className="flex items-center justify-between gap-2 mt-auto flex-row relative">
        {isConnected && isToolConnectable ? (
          <Button
            icon={ExternalLinkLaunch}
            label={t('tools.buttons.launch')}
            variant={buttonType}
            onClick={() => onLaunchTool(tool)}
            size="small"
          />
        ) : (
          <Button
            icon={ExternalLinkLaunch}
            label={`${
              isToolConnectable
                ? t('tools.buttons.connect')
                : isNewTools
                ? t('tools.buttons.launch')
                : t('tools.buttons.open')
            } `}
            variant={buttonType}
            size="small"
            onClick={() => {
              isToolConnectable ? connectTools() : onLaunchTool(tool)
            }}
          />
        )}

        {tool.isRecommended && isReleaseToolEnabled && getCurrentRoute().includes('tools') && (
          <div className="relative">
            <Button
              variant="text"
              label={t('tools.buttons.whatsNext')}
              className="!border-0"
              onClick={() => setOpen(!isOpen)}
            />
            {isOpen && (
              <ToolFlyoutPopup
                setOpen={setOpen}
                isOpen={isOpen}
                handleClick={handleClick}
                toolFlyoutOptions={tool.toolFlyoutOptions || []}
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default ToolsButton
